import Link from 'next/link'
import React from 'react'
import { useGblLocationsByState } from './useGblLocationsByState'

export const ConsultationLocations = () => {
  const stateLocationMap = useGblLocationsByState('ConsultationLocations')

  return (
    <section className="!bg-slate-200 w-full py-16">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl text-center mb-4">CONSULTATION LOCATIONS</h2>
        <p className="text-center text-gray-700 mb-12 max-w-3xl mx-auto">
          We can provide service at your location, or visit us inside Valvoline
          for a consultation
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {Object.entries(stateLocationMap).map(([state, cities]) => (
            <div key={state} className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-xl mb-4 text-navy">{state}</h3>
              <ul className="space-y-2">
                {cities.map((city) => (
                  <li key={`${city.name}-${city.storeID}`}>
                    <Link
                      href={`/locations/${city.slug.replace(/^\/+/, '')}`}
                      className="text-primary hover:text-primary/80 hover:underline transition-colors"
                    >
                      {`${city.name} Store #${city?.storeID}`}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
